/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export const $FileLogStatsIndexResponse = {
    properties: {
        guardianFileLogStatsId: {
            type: 'number',
            isRequired: true,
        },
        rtSchema: {
            type: 'number',
            isRequired: true,
        },
        fileStreamId: {
            type: 'number',
            isRequired: true,
        },
        fileName: {
            type: 'number',
            isRequired: true,
        },
        minInviteTs: {
            type: 'Date',
            isRequired: true,
            format: 'date-time',
        },
        maxInviteTs: {
            type: 'Date',
            isRequired: true,
            format: 'date-time',
        },
        atts: {
            type: 'number',
            isRequired: true,
        },
        inCons: {
            type: 'number',
            isRequired: true,
        },
        egCons: {
            type: 'number',
            isRequired: true,
        },
        hasCstRate: {
            type: 'number',
            isRequired: true,
        },
        hasRevRate: {
            type: 'number',
            isRequired: true,
        },
        noCstRateKey: {
            type: 'number',
            isRequired: true,
        },
        noRevRateKey: {
            type: 'number',
            isRequired: true,
        },
        defCstRateKey: {
            type: 'number',
            isRequired: true,
        },
        defRevRateKey: {
            type: 'number',
            isRequired: true,
        },
        cstRateTtl: {
            type: 'number',
            isRequired: true,
        },
        revRateTtl: {
            type: 'number',
            isRequired: true,
        },
        cstTotalTtl: {
            type: 'number',
            isRequired: true,
        },
        revTotalTtl: {
            type: 'number',
            isRequired: true,
        },
        ttlCst: {
            type: 'number',
            isRequired: true,
        },
        ttlRev: {
            type: 'number',
            isRequired: true,
        },
        ttlMgn: {
            type: 'number',
            isRequired: true,
        },
        createdTs: {
            type: 'Date',
            isRequired: true,
            format: 'date-time',
        },
        updatedTs: {
            type: 'Date',
            isRequired: true,
            format: 'date-time',
        },
        deletedTs: {
            type: 'Date',
            isRequired: true,
            format: 'date-time',
        },
        gflRecQty: {
            type: 'number',
            isRequired: true,
        },
        gflGoodRecQty: {
            type: 'string',
            isRequired: true,
        },
    },
};